import { PermissionRole } from '@fabric/woody-client';

const allowed = {
  allowed: true
};
const ownerPermissions = {
  resource: {
    remove: allowed,
    edit: allowed
  },
  childResources: {
    view: allowed,
    create: allowed,
    remove: allowed,
    edit: allowed
  },
  addOrEditOwnComment: {
    allowed: true
  },
  comments: {
    edit: allowed,
    view: allowed
  },
  permission: {
    canGrantPermissions: [
      PermissionRole.VIEWER,
      PermissionRole.COMMENTER,
      PermissionRole.EDITOR,
      "remove"
    ],
    canEditPublishingSettings: true
  }
};
const editorPermissions = {
  resource: {
    remove: allowed,
    edit: allowed
  },
  childResources: {
    view: allowed,
    create: allowed,
    remove: allowed,
    edit: allowed
  },
  addOrEditOwnComment: {
    allowed: true
  },
  comments: {
    edit: {
      allowed: false,
      info: "You can't delete others comments"
    },
    view: allowed
  },
  permission: {
    canGrantPermissions: [
      PermissionRole.EDITOR,
      PermissionRole.VIEWER,
      PermissionRole.COMMENTER,
      "remove"
    ],
    canEditPublishingSettings: true
  }
};
const commenterPermissions = {
  resource: {
    remove: {
      allowed: false,
      info: "Not allowed as a commenter."
    },
    edit: {
      allowed: false,
      info: "Not allowed as a commenter."
    }
  },
  childResources: {
    view: allowed,
    create: {
      allowed: false,
      info: "Not allowed as a commenter."
    },
    remove: {
      allowed: false,
      info: "Not allowed as a commenter."
    },
    edit: {
      allowed: false,
      info: "Not allowed a commenter."
    }
  },
  addOrEditOwnComment: {
    allowed: true
  },
  comments: {
    edit: {
      allowed: false,
      info: "You can't delete others comments"
    },
    view: allowed
  },
  permission: {
    canGrantPermissions: null,
    canEditPublishingSettings: false
  }
};
const notAllowedAsViewer = "Not allowed as a viewer.";
const viewerPermissions = {
  resource: {
    remove: {
      allowed: false,
      info: notAllowedAsViewer
    },
    edit: {
      allowed: false,
      info: notAllowedAsViewer
    }
  },
  childResources: {
    view: allowed,
    create: {
      allowed: false,
      info: notAllowedAsViewer
    },
    remove: {
      allowed: false,
      info: notAllowedAsViewer
    },
    edit: {
      allowed: false,
      info: notAllowedAsViewer
    }
  },
  addOrEditOwnComment: {
    allowed: false,
    info: notAllowedAsViewer
  },
  comments: {
    edit: {
      allowed: false,
      info: notAllowedAsViewer
    },
    view: {
      allowed: false,
      info: notAllowedAsViewer
    }
  },
  permission: {
    canGrantPermissions: null,
    canEditPublishingSettings: false
  }
};
const getResourcePermissionsByRole = (permission) => {
  switch (permission?.role) {
    case "owner":
      return ownerPermissions;
    case "editor": {
      if (permission.inherited) {
        return editorPermissions;
      } else {
        return {
          ...editorPermissions,
          resource: {
            ...editorPermissions.resource,
            remove: {
              allowed: false,
              info: "Only owner can perform this action."
            }
          }
        };
      }
    }
    case "commenter":
      return commenterPermissions;
    default:
      return viewerPermissions;
  }
};

export { getResourcePermissionsByRole };
//# sourceMappingURL=getResourcePermissionsByRole.js.map
